import React, { lazy } from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const tomos = [{
    name: '365-Day Curriculum',
    desc: 'A complete annual roadmap with structured seasonal programming.'
  }, {
    name: 'Technical Foundation',
    desc: 'The perfect technical base for developing core skills (Dribbling, Passing, Receiving).'
  }, {
    name: 'Tactical Mastery',
    desc: 'Modern pressing and outletting systems explained for every level.'
  }, {
    name: 'THE FLOW System',
    desc: 'Fluid training transitions to maximize ball-contact time and minimize standing around.'
  }, {
    name: 'Game-Speed Drills',
    desc: 'High-tempo sessions designed to increase decision-making speed under pressure.'
  }, {
    name: 'The Match-Day Blueprint',
    desc: 'Professional templates for pre-game talks, substitutions, and tactical adjustments.'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-241">
      <div className="max-w-5xl mx-auto" data-id="element-242">
        <div className="text-center mb-12" data-id="element-243">
          <div className="bg-pilates-lavender/25 text-pilates-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-244">
            INTRODUCING HOCKEY READY™
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-245">
            The Complete Hockey Coach{' '}
            <span className="italic text-pilates-sage-dark" data-id="element-246">
              Operating System
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-247">
          <div data-id="element-248">
            <img src="https://cdn.magicpatterns.com/uploads/uEWrvggmqQrXtSH8StzMch/image_(9).webp" alt="Hockey Ready 6-in-1 Box Set" className="w-full rounded-2xl shadow-xl" loading="lazy" decoding="async" width="800" height="800" data-id="element-249" />
          </div>

          <div data-id="element-250">
            <p className="text-pilates-slate text-base leading-relaxed mb-6" data-id="element-251">
              <span className="font-bold text-pilates-dark" data-id="element-252">Hockey Ready</span>{' '}
              is not just another PDF. It's a complete planning system designed
              to help hockey coaches create professional, structured,
              high-intensity sessions in minutes instead of hours.
            </p>

            <ul className="space-y-4 mt-8" data-id="element-253">
              {tomos.map((tomo, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-254">
                  <div className="mt-0.5 bg-pilates-sage/20 p-1 rounded-full text-pilates-sage-dark flex-shrink-0" data-id="element-255">
                    <Check className="w-4 h-4" data-id="element-256" />
                  </div>
                  <div data-id="element-257">
                    <span className="font-bold text-pilates-dark" data-id="element-258">
                      {tomo.name}
                    </span>{' '}
                    <span className="text-pilates-slate" data-id="element-259">— {tomo.desc}</span>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}